import { connect } from 'react-redux'
import { get, compact } from 'lodash'
import { reduxForm } from 'redux-form'
import IncomingCallForm from './IncomingCallForm'
import showNumbersNewServiceModal from 'features/Numbers/NumbersNewServiceModal'
import { flowServices } from 'features/Numbers/Numbers.utils'

const stateToProps = ({ form, numbers }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
  numberOptions: flowServices(numbers).map(number => ({
    name: compact([number.number, number.customerReference]).join(' - '),
    number: number.twilioFlowService || number.number,
    value: number.twilioFlowServiceId || number.id,
  })),
})

const dispatchToProps = {
  showNumbersNewServiceModal,
}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(IncomingCallForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingCall/IncomingCallForm.container.js